




























































import { confirmDelete } from '@/libs/decorator';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DatasourceServices from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DsPermission from '../../components/ds-permission.vue';
import DsColumns from '../../components/ds-columns.vue';
import AddDsTable from './table-info-add.vue';
import { pagination } from '@/libs/util';

@Component({
  components: { DsPermission, DsColumns, AddDsTable }
})
export default class DatasourceObject extends mixins(BaseFormMixin) {
  @Prop() id!: any;
  @Prop() dsType!: string;

  dsSrv = new DatasourceServices();
  data: any[] = [];
  loading: boolean = false;
  childShow: boolean = true;
  permisionVisible: boolean = false;
  columnsVisible: boolean = false;
  tableVisible: boolean = false;
  tableId: number = 0;
  pagination = pagination;

  @Watch('id')
  async getTableList() {
    this.loading = true;
    this.data = await this.dsSrv.tables({ sourceId_eq: this.id });
    this.loading = false;
  }

  async onCellChange(args: string[], record: any, column: string) {
    record[column] = args[0];
    let params = {
      id: record.id,
      [column]: args[0]
    };
    let res = await this.dsSrv.updateTable(params);
    if (res) this.getTableList();
  }

  @confirmDelete()
  async onDelete(ids: any[]) {
    let res = await this.dsSrv.deleteTables(ids);
    if (res) this.getTableList();
  }

  selectedRows: any[] = [];
  selectedRowKeys: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRowKeys = keys;
    this.selectedRows = rows;
  }
  // 批量操作
  async handleBatch(e: any) {
    if (this.selectedRows.length === 0) {
      this.$message.error('请选中至少一条数据');
      return false;
    }
    if (e.key === 'batchRemove') {
      this.onDelete(this.selectedRowKeys);
      this.selectedRows = [];
      this.selectedRowKeys = [];
    }
    if (e.key === 'batchInput0') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, inputFlag: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchInput1') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, inputFlag: 1 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchOutput0') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, outputFlag: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchOutput1') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, outputFlag: 1 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchEnable') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, status: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchDisable') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, status: 1 }));
      this.batchUpdate(paramsArr);
    }
  }
  // 批量更新
  async batchUpdate(paramsArr: any[]) {
    this.loading = true;
    let promiseArr = paramsArr.map((param: any) => {
      return new Promise(async resolve => {
        await this.dsSrv.updateTable(param).then(res => resolve(res));
      });
    });
    await Promise.all(promiseArr);
    this.loading = false;
    this.getTableList();
    this.selectedRows = [];
    this.selectedRowKeys = [];
  }

  openPermission(record: any) {
    this.permisionVisible = true;
  }

  openColumns(record: any) {
    this.tableId = record.id;
    this.columnsVisible = true;
  }

  columns = [
    { title: '表物理名', dataIndex: 'tableNameEn', key: 'tableNameEn', scopedSlots: { customRender: 'nameEn' } },
    { title: '表逻辑名', dataIndex: 'tableNameCn', key: 'tableNameCn', scopedSlots: { customRender: 'nameCn' } },
    { title: '输入', dataIndex: 'inputFlag', key: 'inputFlag', width: 120, scopedSlots: { customRender: 'inputFlag' } },
    { title: '输出', dataIndex: 'outputFlag', key: 'outputFlag', width: 120, scopedSlots: { customRender: 'outputFlag' } },
    { title: '启用', dataIndex: 'status', key: 'status', width: 120, scopedSlots: { customRender: 'status' } },
    { title: '操作', dataIndex: 'operation', key: 'operation', width: 170, scopedSlots: { customRender: 'operation' } }
  ];

  
}
